import type { ReconReservedViews } from 'types/reconciliation-v2/ReconCommon';

export const reconReservedViews = {
  list: 'list',
  board: 'board',
  timeline: 'timeline',
  calendar: 'calendar',
} as const satisfies Record<ReconReservedViews, ReconReservedViews>;

export const reconNewViewId = 'new-view';
